import { EXPRESS_API } from 'configs/api/expressApi';
import { ISourceType } from 'lib/components/modal/mergeModal/types';
import { errorToast } from 'lib/components/toasts/error';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

interface MergeVideoItem {
  start: string;
  end: string;
  id: string;
  flvName: string;
}

interface MergeParams {
  videos: MergeVideoItem[];
  videoName: string;
  duration: number;
  sources?: ISourceType[];
}

const mergeVideoEntities = async (body: MergeParams) => {
  const response = await EXPRESS_API.post(`/videos/merge`, body);
  return response.data;
};

export const useVideosMergeMutation = () => {
  const { t } = useTranslation();

  return useMutation(mergeVideoEntities, {
    onError: () => {
      errorToast({
        title: t('Error in merging videos!'),
      });
    },
  });
};
